/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ParticipantRole } from './ParticipantRole.js';
import {
    ParticipantRoleFromJSON,
    ParticipantRoleFromJSONTyped,
    ParticipantRoleToJSON,
} from './ParticipantRole.js';

/**
 * 
 * @export
 * @interface Utterance
 */
export interface Utterance {
    /**
     * 
     * @type {number}
     * @memberof Utterance
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof Utterance
     */
    dateStarted?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Utterance
     */
    dateEnded?: Date;
    /**
     * 
     * @type {number}
     * @memberof Utterance
     */
    contactId?: number;
    /**
     * 
     * @type {string}
     * @memberof Utterance
     */
    transcript?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Utterance
     */
    isQuestion?: boolean;
    /**
     * 
     * @type {ParticipantRole}
     * @memberof Utterance
     */
    participantRole?: ParticipantRole;
}

/**
 * Check if a given object implements the Utterance interface.
 */
export function instanceOfUtterance(value: object): boolean {
    return true;
}

export function UtteranceFromJSON(json: any): Utterance {
    return UtteranceFromJSONTyped(json, false);
}

export function UtteranceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Utterance {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'dateStarted': json['dateStarted'] == null ? undefined : (new Date(json['dateStarted'])),
        'dateEnded': json['dateEnded'] == null ? undefined : (new Date(json['dateEnded'])),
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'transcript': json['transcript'] == null ? undefined : json['transcript'],
        'isQuestion': json['isQuestion'] == null ? undefined : json['isQuestion'],
        'participantRole': json['participantRole'] == null ? undefined : ParticipantRoleFromJSON(json['participantRole']),
    };
}

export function UtteranceToJSON(value?: Utterance | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'dateStarted': value['dateStarted'] == null ? undefined : ((value['dateStarted']).toISOString()),
        'dateEnded': value['dateEnded'] == null ? undefined : ((value['dateEnded']).toISOString()),
        'contactId': value['contactId'],
        'transcript': value['transcript'],
        'isQuestion': value['isQuestion'],
        'participantRole': ParticipantRoleToJSON(value['participantRole']),
    };
}

